import Icon from '@/components/ui/AppIcon';

export default function ServiceHeroSection() {
  return (
    <section className="relative pt-32 pb-20 px-6 lg:px-12 bg-gradient-to-b from-black via-card to-black">
      <div className="max-w-[1400px] mx-auto text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-primary/10 border border-primary/30 backdrop-blur-md px-6 py-2 rounded-full mb-8">
          <Icon name="WrenchScrewdriverIcon" size={16} variant="outline" className="text-primary" />
          <span className="text-primary font-heading text-xs tracking-[0.3em]">
            SERVICIOS PREMIUM
          </span>
        </div>

        {/* Headline */}
        <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl text-white mb-6 tracking-tight">
          CUATRO PILARES DE
          <br />
          <span className="text-gradient-red">PROTECCIÓN AUTOMOTRIZ</span>
        </h1>

        {/* Description */}
        <p className="text-white/70 text-lg md:text-xl max-w-3xl mx-auto leading-relaxed">
          Tecnología de nivel competición aplicada a tu vehículo de lujo. Cada servicio está diseñado para máxima protección y acabado de concesionario.
        </p>

        {/* Decorative Pattern */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 opacity-10 pointer-events-none">
          <div className="absolute inset-0 bg-gradient-to-b from-primary/20 to-transparent blur-3xl" />
        </div>
      </div>
    </section>
  );
}